
import React, { Component } from 'react';
import { getMainCookie, checkStatus, getFullDate, checkText } from '../../../util/util';
import RCPagination from '../../components/UserControl/Pagination/RCPagination';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { AlertConfirm, AlertCommit, Alert } from '../../Modals/AlertBar';
import $ from "jquery";
import DateTimeRange from '../../components/UserControl/DateTimeRange/DateTimeRange';


let token ;
class OwnerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newExpireDate: moment(),
            paymentData: {
                data: [],
                currentPageSize: 20,
                currentPage: 1
            },
            rfidData: {
                data: [],
                currentPageSize: 20,
                currentPage: 1
            },
            deviceData: {
                data: [],
                currentPageSize: 20,
                currentPage: 1,
                startHistoryDate: moment(),
                endHistoryDate: moment(),
            },
            isDisableDate: true
        }
    }
    componentDidMount() {
        token = this.props.token;
        this.getPaymentList(1, 20);
        this.getDeviceInstallWithRFID(1, 20);
        this.getDeviceSummaryByDealer(true);
    }
    onClickBack() {
        this.props.onExitPage();
    }
    onPaymentDataPageSelect(page) {
        const { currentPageSize } = this.state.paymentData;
        this.getPaymentList(page, currentPageSize);
        $(".collapse").removeClass("show");
    }
    onPaymentDataPageSizeChange(page, pageSize) {
        this.getPaymentList(page, pageSize);
    }
    onRFIDDataPageSelect(page) {
        const { currentPageSize } = this.state.rfidData;
        this.getDeviceInstallWithRFID(page, currentPageSize);
    }
    onRFIDDataPageSizeChange(page, pageSize) {
        this.getDeviceInstallWithRFID(page, pageSize);
    }

    handleNewExpireChangeDate(date) {
        this.setState({
            newExpireDate: date
        });

    }
    getPaymentList(page, size) {
        let thisCur = this;
        fetch("http://203.150.199.244/api/admin/getPaymentList/" + page + "/" + size, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({

            })
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            console.log("data", data)
            if (data.RESULT_DATA && data.RESULT_DATA.length > 0) {
                thisCur.setState(
                    {
                        paymentData: {
                            data: data.RESULT_DATA,
                            totalPage: data.RESULT_TOTAL,
                            currentPage: page,
                            currentPageSize: size
                        }

                    });
            }
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )
    }
    getDeviceInstallWithRFID(page, size) {
        let thisCur = this;
        fetch("http://203.150.199.244/api/report/getDeviceInstallWithRFID/" + page + "/" + size, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({

            })
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            console.log("data", data)
            if (data.RESULT_DATA && data.RESULT_DATA.length > 0) {
                thisCur.setState(
                    {
                        rfidData: {
                            data: data.RESULT_DATA,
                            totalPage: data.RESULT_TOTAL,
                            currentPage: page,
                            currentPageSize: size
                        }

                    });
            }
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )
    }
    getDeviceSummaryByDealer(isAll) {
        let thisCur = this;
        fetch("http://203.150.199.244/api/report/getDeviceSummaryByDealer", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token": token
            },
            body: JSON.stringify({
                "start_date": isAll ? null : moment(thisCur.state.deviceData.startHistoryDate).format("DD-MM-YYYY"),
                "end_date": isAll ? null : moment(thisCur.state.deviceData.endHistoryDate).format("DD-MM-YYYY")
            })
        }).then(function (response) {
            return checkStatus(response);
        }).then((data) => {
            console.log("data", data)
            if (data.RESULT_DATA) {
                thisCur.setState(
                    {
                        deviceData: {
                            data: data.RESULT_DATA,
                            totalPage: data.RESULT_TOTAL,
                            // currentPage: page,
                            // currentPageSize: size
                        }

                    });
            }
        },
            (error) => {
                console.log("error", error)
                return error;
            }

        )
    }
    callUpdateExpire() {
        AlertConfirm("ต่ออายุการใช้งาน", "คุณต้องการแก้ไขอายุการใช้งานหรือไม่").then(isOk => {
            if (isOk) {
                let thisCur = this;
                fetch("http://203.150.199.244/api/admin/paymentExtendDeviceExpire/" + this.refs.txtPaymentID.value + "/" + this.refs.txtDeviceID.value, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "token": token
                    },
                    body: JSON.stringify({
                        expire_date: moment(thisCur.state.newExpireDate).format("DD-MM-YYYY"),

                    })
                }).then(function (response) {
                    return checkStatus(response);
                }).then((data) => {
                    console.log("data", data)
                    if (data.RESULT_STATUS == "000") {
                        const { currentPage, currentPageSize } = thisCur.state.paymentData;
                        thisCur.getPaymentList(currentPage, currentPageSize);
                        Alert("ต่ออายุใช้งานเรียบร้อยแล้ว ");
                        thisCur.btnPaymentExpireClose.click();
                    }
                    else {
                        AlertCommit(false, data.RESULT_STATUS + ": " + data.RESULT_MESSAGE);
                    }
                },
                    (error) => {
                        console.log("error", error)
                        return error;
                    }

                )
            }
        });

    }
    handlePaymentExpire(payment_id, car) {
        this.refs.txtPaymentExpire.innerHTML = car.expire_date;
        this.refs.txtPamentDeviceNo.innerHTML = car.device_no;
        this.refs.txtPaymentID.value = payment_id;
        this.refs.txtDeviceID.value = car.device_id;
        this.setState({
            newExpireDate: moment()
        });
    }
    setDeviceRangeDate(sDate, eDate) {
        if(this.state.isDisableDate)
            return;
        this.state.deviceData.startHistoryDate = sDate;
        this.state.deviceData.endHistoryDate = eDate;
        if (sDate && eDate && sDate != null && eDate != null) {
            this.state.deviceData.startHistoryDate = sDate.toObject();
            this.state.deviceData.endHistoryDate = eDate.toObject();

            this.getDeviceSummaryByDealer();
        }

    }
    handleDeviceAll() {
        let isChk = $('#chkDeviceAll').is(":checked");
        this.state.isDisableDate = isChk;
        this.setState();
        if(isChk){
            this.getDeviceSummaryByDealer(true);
        }
        else{
            this.getDeviceSummaryByDealer();
        }
            
    }


    render() {
        /***   
         * 
         * payment
         * 
        */
        let rPay = [];
        this.state.paymentData.data.map((pay, index) => {
            let no = (this.state.paymentData.currentPage - 1) * this.state.paymentData.currentPageSize + (1 + index);
            rPay.push(
                <tr>
                    <td>{no}</td>
                    <td>{pay.payment_id}</td>
                    <td style={{ textAlign: "center" }}>{pay.customer_name}</td>
                    <td style={{ textAlign: "center" }}>{pay.transaction_dtm}</td>
                    <td style={{ textAlign: "center" }}>{pay.originate_banking}</td>
                    <td style={{ textAlign: "center" }}>{pay.banking}</td>
                    <td>{pay.amount}</td>
                    <td>{pay.remark}</td>
                    <td style={{ textAlign: "center", color: "#009fff", border: "1px solid #ccc" }}><a href={"http://203.150.199.244/api/admin" + pay.attachs[0].img} target="_blank"><i class="fas fa-paperclip" ></i></a></td>
                    <td style={{ textAlign: "center", color: "#009fff", border: "1px solid #ccc" }} >
                        <i class="fas fa-car" data-toggle="collapse" data-target={"#collPayment" + no} style={{ cursor: "pointer" }}></i>
                    </td>
                </tr>
            )
            let rCar = [];

            pay.devices.map((car, i) => {
                rCar.push(

                    <div className="col-sm-12 col-md-6">
                        <div className="row">
                            <div className="col-10" style={{ border: "1px dashed #ccc" }}>
                                {(i + 1) + ". " + car.device_no + " หมดอายุ: " + car.expire_date}
                            </div>
                            <div className="col-2" style={{ paddingTop: 2, paddingBottom: 2 }}>
                                <button type="button" className="btn btn-primary btn-sm"
                                    data-toggle="modal" data-target="#paymentExpire" onClick={this.handlePaymentExpire.bind(this, pay.payment_id, car)}>ต่ออายุ</button >
                            </div>
                        </div>

                    </div>



                )
            })
            rPay.push(
                <tr id={"collPayment" + no} class="collapse">
                    <td>

                    </td>
                    <td colSpan={9}>
                        <div className="row">
                            {rCar}
                        </div>
                    </td>
                </tr>
            )
        })
        if (rPay.length == 0) {
            rPay.push(
                <tr>
                    <td colSpan={10} style={{ textAlign: "center" }}>ไม่พบข้อมูล</td>
                </tr>
            )
        }


        /***   
         * 
         * not user card devices 
         * 
        */
        let rRFID = [];
        this.state.rfidData.data.map((rfid, index) => {
            let no = (this.state.rfidData.currentPage - 1) * this.state.rfidData.currentPageSize + (1 + index);
            rRFID.push(
                <tr>
                    <td>{no}</td>
                    <td>{rfid.device_no}</td>
                    <td style={{ textAlign: "center" }}>{rfid.dealer}</td>
                    <td style={{ textAlign: "center" }}>{rfid.sub_dealer}</td>
                    <td style={{ textAlign: "center" }}>{rfid.customer}</td>
                </tr>
            )

        })
        if (rRFID.length == 0) {
            rRFID.push(
                <tr>
                    <td colSpan={5} style={{ textAlign: "center" }}>ไม่พบข้อมูล</td>
                </tr>
            )
        }


        /***   
       * 
       * devices 
       * 
      */
        let rDevice = [];
        if (this.state.deviceData.data && this.state.deviceData.data.dealers) {
            this.state.deviceData.data.dealers.map((device, index) => {
                let no = index + 1;//(this.state.deviceData.currentPage - 1) * this.state.deviceData.currentPageSize + (1 + index);
                rDevice.push(
                    <tr>
                        <td>{no}</td>
                        <td style={{ textAlign: "center" }}>{device.dealer_name}</td>
                        <td style={{ textAlign: "center" }}>{device.total_device}</td>
                        <td style={{ textAlign: "center" }}>{device.internal_device}</td>
                        <td style={{ textAlign: "center" }}>{device.external_device}</td>
                    </tr>
                )

            })
        }

        if (rDevice.length == 0) {
            rDevice.push(
                <tr>
                    <td colSpan={5} style={{ textAlign: "center" }}>ไม่พบข้อมูล</td>
                </tr>
            )
        }

        return (
            <div>
                <h5 style={{ marginLeft: 5, cursor: 'pointer', width: 300 }} onClick={this.onClickBack.bind(this)}>
                    <i
                        className="fa fa-arrow-left"
                        aria-hidden="true"
                        style={{ color: 'rgb(115, 134, 213)' }} />
                    <i className="fas fa-star-of-life" style={{ color: '#7386D5', marginLeft: 10, marginRight: 5, cursor: "pointer" }} /> ภาพรวม
                </h5>
                <div className="gray-panel" >

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12" style={{border:"1px dashed #eae8e8"}}>
                            <h6><i className="fas fa-credit-card" style={{ color: "#ff7800" }}></i> ตารางแจ้งชำระเงิน</h6>
                            <table class="table table-hover " style={{ backgroundColor: "#fff" }}>
                                <thead>
                                    <tr style={{ textAlign: "center", backgroundColor: "#ff7800", color: "#fff" }}>
                                        <th style={{ textAlign: "left" }}>#</th>
                                        <th style={{ textAlign: "left" }} >รหัสแจ้งโอน</th>
                                        <th >ชื่อลูกค้า</th>
                                        <th >วันที่โอน</th>
                                        <th >ธ.ต้นทาง</th>
                                        <th >ธ.ปลายทาง</th>
                                        <th >ยอดโอน</th>
                                        <th >หมายเหตุ</th>
                                        <th style={{ width: 50 }}>ไฟล์</th>
                                        <th style={{ width: 50 }} >รถ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rPay}
                                </tbody>
                            </table>
                            <div className="col-12" style={{ marginTop: 5 }} >
                                <RCPagination
                                    onSelect={this.onPaymentDataPageSelect.bind(this)}
                                    onShowSizeChange={this.onPaymentDataPageSizeChange.bind(this)}
                                    total={this.state.paymentData.totalPage}
                                    currentPage={this.state.paymentData.currentPage}
                                    pageSize={this.state.paymentData.currentPageSize}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6" style={{border:"1px dashed #eae8e8"}}>
                            <h6><i className="fas fa-box" style={{ color: "#ff7800",marginTop:41 }}></i> ตารางเครื่องรูดบัตรที่ไม่เคยถูกใช้งาน</h6>
                            <table class="table table-hover " style={{ backgroundColor: "#fff" }}>
                                <thead>
                                    <tr style={{ textAlign: "center", backgroundColor: "#ff7800", color: "#fff" }}>
                                        <th style={{ textAlign: "left" }}>#</th>
                                        <th style={{ textAlign: "left" }} >ทะเบียน</th>
                                        <th >dealer</th>
                                        <th >sub dealer</th>
                                        <th >customer</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rRFID}
                                </tbody>
                            </table>
                            <div className="col-12" style={{ marginTop: 5 }} >
                                <RCPagination
                                    onSelect={this.onRFIDDataPageSelect.bind(this)}
                                    onShowSizeChange={this.onRFIDDataPageSizeChange.bind(this)}
                                    total={this.state.rfidData.totalPage}
                                    currentPage={this.state.rfidData.currentPage}
                                    pageSize={this.state.rfidData.currentPageSize}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6" style={{alignSelf:"self-end",border:"1px dashed #eae8e8"}}>
                            <h6><i className="fas fa-box" style={{ color: "#ff7800" }}></i> ตารางกล่อง จำนวน
                            {" " + this.state.deviceData.data.total_device + "(บ. " + this.state.deviceData.data.internal_device + "/จูน " + this.state.deviceData.data.external_device + ") กล่อง"}</h6>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <table>
                                        <tr>
                                            <td>
                                                ช่วงเวลา
                                            </td>
                                            <td>
                                                <DateTimeRange
                                                    small={true}
                                                    isBack
                                                    startDateId="MyDatePicker"
                                                    endDateId="your_unique_end_date_id"
                                                    isDisable={this.state.isDisableDate}
                                                    onSelectDate={this.setDeviceRangeDate.bind(this)} />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="col-sm-12 col-md-6" >
                                    <div className="checkbox" >
                                        <label style={{top:10}}>
                                            <input type="checkbox" id="chkDeviceAll" defaultChecked={true}
                                                onClick={this.handleDeviceAll.bind(this)} />
                                            <span className="cr" style={{ backgroundColor: "#fff" }}><i className="cr-icon fa fa-check"></i>
                                            </span>
                                        </label>
                                        <label for="chkDeviceAll">แสดงกล่องทั้งหมด</label>
                                    </div>
                                </div>
                                <table class="table table-hover col-12" style={{ backgroundColor: "#fff" }}>
                                    <thead>
                                        <tr style={{ textAlign: "center", backgroundColor: "#ff7800", color: "#fff" }}>
                                            <th style={{ textAlign: "left" }}>#</th>
                                            <th >dealer</th>
                                            <th >กล่องทั้งหมด</th>
                                            <th >กล่องบริษัท</th>
                                            <th >กล่องจูน</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rDevice}
                                    </tbody>
                                </table>
                            </div>

                            
                            
                            
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="paymentExpire" tabIndex={-1} role="dialog" aria-labelledby="paymentExpire" aria-hidden="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading" style={{ alignSelf: "center" }}> {"ต่ออายุรถ "}<span ref="txtPamentDeviceNo"></span> </h4>
                                <button ref={input => this.btnPaymentExpireClose = input} type="button" className="close" style={{ padding: 0, margin: 0 }} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">วันหมดอายุเดิม</label>
                                    <div className="col-md-9" style={{ alignSelf: "center" }}>
                                        <span ref="txtPaymentExpire"></span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label htmlFor="example-text-input" className="col-md-3 col-form-label">วันหมดอายุใหม่</label>
                                    <div className="col-md-9">
                                        <DatePicker className="form-control" style={{ height: 32 }}
                                            selected={this.state.newExpireDate}
                                            onChange={this.handleNewExpireChangeDate.bind(this)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button onClick={this.callUpdateExpire.bind(this)} type="button" className="btn btn-primary btn-lg" style={{ width: '100%' }} ><span className="fa fa-check" />&nbsp;ต่ออายุการใช้งาน</button>
                            </div>
                        </div>

                    </div>
                </div>
                <input type="hidden" ref="txtDeviceID" />
                <input type="hidden" ref="txtPaymentID" />
            </div>


        );
    }
}
export default OwnerPage;


// WEBPACK FOOTER //
// ./src/app/view/containers/MainSummary/OwnerPage.js